/** Ajuda — Cardápio: produtos, combos, pizza, personalização, categorias e turnos. */
export const cardapio = {
  id: "cardapio",
  titulo: "Cardápio e produtos",
  icone: "Store",
  intro: "Como montar o cardápio: produtos simples, combos, pizzas, etapas de personalização, categorias e turnos por horário.",
  topicos: [
    {
      pergunta: "Como cadastro um produto?",
      resposta: "Em Cardápio → Produtos, clique em Novo Produto: nome, categoria, preço, foto e descrição (o botão de IA escreve a descrição pra você a partir do nome). Dá pra escolher em quais canais o produto aparece (cardápio online, delivery, mesas, balcão) e até definir preço diferente por canal.",
      videos: ["GWR7awqNj9g"],
    },
    {
      pergunta: "Qual a diferença entre produto simples e combo?",
      resposta: "O combo tem dois preços: o SIMPLES (só o item) e o do COMBO (com acompanhamentos, ex.: lanche + batata + bebida). No cardápio o cliente escolhe qual quer; no popup, a versão combo abre as etapas de montagem. Os relatórios mostram quanto cada versão vendeu.",
    },
    {
      pergunta: "Como funcionam as etapas de personalização?",
      resposta: "Na edição do produto, a aba Personalização cria etapas que o cliente percorre ao pedir (ex.: Ponto da carne → Adicionais → Molhos). Cada etapa tem seus itens, com preço e quantidade mínima/máxima; itens podem ser gratuitos ou pagos, e o cliente pode repetir o mesmo adicional mais de uma vez.",
      videos: ["MXkCAW6_UN4"],
    },
    {
      pergunta: "Como cadastro pizzas com tamanhos, sabores e bordas?",
      resposta: "Produto do tipo Pizza ganha etapas fixas: Tamanho, Sabores (1 ou mais, com preço por fração), Borda e adicionais. A regra de preço de múltiplos sabores é configurável (ex.: cobrar o sabor mais caro ou a média). Todo produto-pizza aparece automaticamente como sabor dele mesmo, e os preços por tamanho ficam numa tabela própria na edição.",
    },
    {
      pergunta: "Produto acabou no meio do dia. Marco como esgotado ou escondo?",
      resposta: "Marque como ESGOTADO (indisponível): ele continua visível no cardápio com o selo de esgotado — o cliente entende que existe e volta amanhã. OCULTAR remove o produto de todos os canais de venda (bom pra item sazonal). As duas opções ficam no card do produto e valem na hora.",
      videos: ["H8L5j1NsEuM"],
    },
    {
      pergunta: "Como organizo as categorias?",
      resposta: "Em Cardápio → Categorias você cria, renomeia, reordena (a ordem do painel é a ordem do cardápio online) e oculta categorias inteiras. Categoria oculta some do cardápio do cliente, mas os produtos continuam disponíveis pro PDV da sua equipe.",
      videos: ["pYM40n-hctA"],
    },
    {
      pergunta: "O que são os Turnos do Cardápio?",
      resposta: "São janelas de horário que definem QUAIS categorias o cliente vê em cada período — ex.: Almoço (11h–15h) mostra só pratos executivos; Jantar (18h–23h) mostra pizzas e lanches. Configura-se em Cardápio → Categorias → Turnos do Cardápio, escolhendo dias, horário e categorias de cada turno. Fora dos turnos, o cardápio completo aparece. Vale pro cardápio online, pro bot e pro totem — o PDV da sua equipe NÃO é recortado e continua vendendo tudo a qualquer hora.",
    },
    {
      pergunta: "Turnos sobrepostos: o que acontece?",
      resposta: "As categorias se SOMAM. Se o Almoço vai até 15h e o Happy Hour começa às 14h, entre 14h e 15h o cliente vê as categorias dos dois turnos. O painel avisa quando você salva um turno que cruza outro, e o selo ATIVO AGORA mostra todos os turnos valendo neste momento.",
    },
    {
      pergunta: "Consigo importar meu cardápio de outro sistema?",
      resposta: "Sim — em Configurações → Sistema → Integração há importadores (ex.: GrandChef, Anota AÍ). Eles trazem categorias, produtos, preços e fotos; depois é só revisar e ajustar personalizações.",
    },
    {
      pergunta: "O que o cliente vê no cardápio online além dos produtos?",
      resposta: "Status de aberto/fechado com horário, busca, categorias na sua ordem, promoções ativas, sugestões de \"que tal adicionar?\" no carrinho, \"Peça de novo\" com os últimos pedidos do cliente logado, e o acompanhamento do pedido em tempo real após finalizar (com a linha do tempo do status).",
      videos: ["0Eb2VCgJDbY"],
    },
  ],
};
